<template>
    <div>
        <div style=""><img :src="require('@/assets/exit.png')" style="width:20px; float:right; margin-top:20px; margin-right:20px;" @click="() => {$GlobalStore.closeLastModal();}"></div>
        <div style="padding: 0px 25px;">
            <template v-if="step === -1">
                <div class="title" style="">다양한 레슨권이 있어요</div>
                <div class="detail" style="">어느 레슨권을 사용해볼까요?</div>
            </template>
            <template v-if="step === 0">
                <div class="title" style="">다양한 코치님들이 있어요</div>
                <div class="detail" style="">어느 코치님께 레슨 받아볼까요?</div>
            </template>
            <template v-if="step === 1">
                <div class="title" >레슨 시간 정하기!</div>
                <div class="detail" >레슨 받으실 시간을 정해주세요 :)</div>
            </template>
            <template v-if="step === 2" >
                <div class="title" style="text-align:center;">레슨 예약이 완료되었어요!</div>
                <div class="detail" style="text-align:center;">축짱이 되길 바랄게요 :)</div>
            </template>
        </div>



        <div style="margin-top:70px;" v-if="step === 0 || step === -1">
            <div style="display:flex; padding:0px 50px; ">
                <div style="">
                    <img :src="require('@/assets/branch_no.png')" style="width:70px;">
                </div>
                <div style="display:flex; align-items: center; font-size:20px; font-weight:900; padding-left:15px;">{{branch.name}}</div>
            </div>
            <div v-if="step === 3" style="height:30px;"></div>
            <div style="display:grid; place-items: center; padding:5px 0px;" v-if="step !== 3">
                <img :src="require('@/assets/show_more.png')" style="transform: rotate(90deg); width:23px;">
            </div>
        </div>

        <div style="overflow:auto; flex:1;" v-if="step === -1">
            <div v-for="each, i in memberships" :key="i" class="select_row2" :class="selectedMembershipIdx == each.membership_idx ? 'active' : ''"
                 @click="setMembership(each)" >{{each.membership_name}}</div>

        </div>

        <div style="overflow:auto; flex:1;" v-if="step === 0">
            <div v-for="each, i in coaches" :key="i" @click="setCoach(each)" style="padding:5px 10px;">
                <div style="display:flex;" class="select_row" :class="coachIdx === each.coach_idx ? 'active' : ''">
                    <div style="padding:10px;">
                        <img :src="each.image_path ? $resourcePath + each.image_path : require('@/assets/profile.png')" style="width:80px;" @error="(e) => {e.target.src = require('@/assets/profile.png')}">
                    </div>
                    <div style="flex:1; padding-top:5px; margin-left:10px;">
                        <div style="font-weight:900; font-size:17px; color:#e17329;">{{each.position}}</div>
                        <div style="margin-top: 2px;font-size:13px; color:#e17329;">{{each.career ? each.career : '&nbsp;'}}</div>
                        <div style="margin-top: 5px;font-size:28px; font-weight:900;color:#464646; ">{{each.coach_name}} 코치</div>
                        <div style="margin-top: 10px;font-size:13px; color:#535353;">{{each.tag}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="step === 1" style="margin-top:26px;">
            <div class="detail" style="padding: 0px 25px;">레슨 날짜 선택</div>
            <div style="padding:5px;">
                <HorizonScrollWrap style="border-radius:10px; border:1px solid #ff9041; padding-top:3px; padding-bottom:3px;">
                    <div v-for="each, i in dates" :key="i" class="date_wrap" :class="[dateIndex === i ? 'active' : '']" style="" @click="setDate(each, i)">
                        <div style="margin-top:20px; font-size:14px;">{{each.dayStr}}</div>
                        <div style="margin-top:15px; font-size:23px; font-weight:900;">{{each.dateStr}}</div>
                        <div style="margin-top:15px; font-size:14px;">{{i === 0 ? '오늘' : ''}}</div>
                    </div>
                </HorizonScrollWrap>
            </div>
            <div class="detail" style="padding: 0px 25px;">시간 선택</div>
        </div>
        <div v-if="step === 1" style="overflow:auto; flex:1;">
            <div style="padding:10px 20px;">
                <div v-for="each, i in schedules" :key="i" class="time_wrap" :class="[selectedScheduleIdx === each.schedule_idx ? 'active' : '', each.display === 'available' || each.display === 'canceled' ? '' : 'disable']" @click="setSchedule(each)">{{each.begin_time}}</div>
            </div>
        </div>
        <div v-if="step === 1" style="padding:20px; border-bottom:1px solid #c6c6c6;">
            <div class="round_btn">{{selectedMembership.membership_name}}</div>
            <div class="round_btn" v-if="selectedDate.date">{{$Util.setDateToMD(selectedDate.date)}} 시작</div>
            <div class="round_btn" style="min-width:72px;" v-if="selectedSchedule.begin_time">{{selectedSchedule.begin_time}}</div>
        </div>
        <div v-if="step === 2" style="padding:40px 60px; ">
            <div style="border:1px solid #ff6c03; text-align:center; border-radius:10px; padding: 30px 0px;">
                <img :src="require('@/assets/profile.png')" style="width:100px;">
                <div style="font-size:28px; font-weight:900; margin-top:10px;">{{selectedCoach.coach_name}} 코치</div>
                <div style="margin-top:60px;">
                    <div class="round_border">{{selectedMembership.membership_name}}</div>
                </div>
                <div style="margin-top:10px;">
                   <div class="round_border">{{$Util.setDateToMD(selectedDate.date)}} 시작</div>
                </div>
                <div style="margin-top:10px;">
                    <div class="round_border">{{selectedSchedule.begin_time}}</div>
                </div>

            </div>
            <!--<div style="text-align:center; text-decoration: underline; font-weight:800; font-size:17px; margin-top:20px; color:#565656;">스케줄 고정 요청</div>-->
        </div>
        <div v-if="step === 2" style="flex:1;"></div>
        <div style="display:flex; padding:20px; justify-content: center; align-items: center; border-top:1px solid #c6c6c6;" v-if="step === 2">
            <div class="next_btn" style="" @click="close">완료</div>
        </div>
        <div style="display:flex; padding:20px;" v-if="step === -1 || step === 0 || step === 1">
            <div style="flex:1;"></div>
            <div >
                <div v-if=" step === -1 || step === 0" class="next_btn" style="" @click="goNextStep">다음</div>
                <div v-if="step === 1" class="next_btn" style="font-size:14px;padding:0px 15px; font-weight:normal;" @click="reserve" >레슨 예약하기</div>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';
    import HorizonScrollWrap from "../../common/HorizonScrollWrap";

    export default {
        name: "Reservation",
        components: {HorizonScrollWrap},
        props : {
            memberships : Array,
            branch : Object,
            pCoachIdx : {
                type : String,
                default : '-1'
            }
        },
        data(){
            return {
                step : 0,
                coachIdx : -1,
                selectedCoach : {},
                coaches : [],
                dates : [],
                dateIndex : -1,
                selectedDate : {},
                selectedMembership : {},
                selectedMembershipIdx : -1,
                schedules : [],
                selectedScheduleIdx : -1,
                selectedSchedule : {},
            }
        },
        methods : {
            goPrevStep(){
                this.step--;
            },
            goNextStep(){
                if(this.step === 0 && this.coachIdx === -1){
                    alert('코치를 선택해주세요.');
                    return;
                }

                if(this.step === -1){
                    //지점상세
                    if(this.pCoachIdx === '-1'){
                        this.getCoaches();
                    //코치상세
                    }else {
                        this.step = 1;
                        return;
                    }

                }

                this.step++;
            },
            setCoach(coach){
                this.coachIdx = coach.coach_idx;
                this.selectedCoach = coach;
            },
            setMembership(each){
                this.selectedMembership = each;
                this.selectedMembershipIdx = each.membership_idx;
            },
            async getCoaches(){
                const parameters = {};
                parameters.saleMembershipIdx = this.selectedMembership.saleMembership_idx;
                const res = await this.$Axios.get('/api/branch/reservation/coaches', {params : parameters});
                this.coaches = res.data.coaches;
            },
            setDates(){
                const newDates = [];
                for(let i = 0; i < 30; i++){
                    const curMoment = moment().add(i, 'days');
                    const day =  curMoment.day();

                    const json = {
                        date : curMoment.format('YYYY-MM-DD'),
                        dateStr : parseInt(curMoment.format('DD')),
                        day : day,
                        dayStr : this.$Util.initialStrFromDay(day)
                    };
                    newDates.push(json);
                }

                this.dates = newDates;
            },
            setDate(each, i){
                this.dateIndex = i;
                this.selectedDate = each;
                this.selectedSchedule = {};
                this.selectedScheduleIdx = -1;
                this.getSchedules();
            },
            async getSchedules(){
                const parameters = {};
                parameters.targetDate = this.selectedDate.date;
                parameters.saleMembershipIdx = this.selectedMembership.saleMembership_idx;
                parameters.coachIdx = this.coachIdx;
                parameters.branchIdx = this.branch.idx;
                const res = await this.$Axios.get('/api/branch/schedules/available', {params : parameters});
                this.schedules = res.data.schedules;
            },
            setSchedule(schedule){
                if(schedule.display !== 'available' && schedule.display !== 'canceled') return;
                this.selectedScheduleIdx = schedule.schedule_idx;
                this.selectedSchedule = schedule;
            },
            async reserve(){
                if(!this.selectedDate.date){
                    alert('날짜를 선택해주세요.');
                    return;
                }

                if(this.selectedScheduleIdx === -1){
                    alert('시작시간을 선택해주세요.');
                    return;
                }

                const parameters = {};
                parameters.scheduleIdx = this.selectedScheduleIdx;
                parameters.saleMembershipIdx = this.selectedMembership.saleMembership_idx;
                parameters.coachIdx = this.coachIdx;
                parameters.type = this.selectedSchedule.type;
                parameters.branchIdx = this.branch.idx;
                const res = await this.$Axios.post('/api/branch/reserve', parameters);
                if(res.data.code === 0){
                    this.step++;
                }else {
                    alert(res.data.message);
                }
            },
            close(){
                this.$GlobalStore.closeLastModal();
            }
        },
        created(){
            this.reserve = this.$Once(this.reserve);

            if(this.memberships.length === 1){
                this.selectedMembership = this.memberships[0];

                //지점 상세에서
                if(this.pCoachIdx === '-1'){
                    this.getCoaches();
                //코치 상세에서
                }else {
                    this.step = 1;
                }

            }else {
                this.step = -1;
            }

            if(this.pCoachIdx !== '-1') {
                this.coachIdx = this.pCoachIdx;
            }

            this.setDates();
        }
    }
</script>

<style scoped>
    .title{font-size:25px; font-weight:900; color:#565656;}
    .detail{font-size:20px; font-weight:bold; margin-top:6px; color:#565656}
    .select_row{border:1px solid white;border-radius:10px; }
    .select_row.active{border:1px solid #ff6c03;}

    .select_row2{margin-left:10px; margin-right:10px; border-radius:10px; display:grid; place-items: center; font-size:28px; font-weight:900; height:100px; color:#464646; border:1px solid white;}
    .select_row2.active{border:1px solid #ff6c03;}

    .date_wrap{display:inline-block; width:50px; border:1px solid transparent; color:#bdbdbd; border-radius:10px; padding:15px 13px; height:145px; text-align:center; vertical-align: top;}
    .date_wrap + .date_wrap{margin-left:5px;}
    .date_wrap.active{color:#ff6c03; border-color: #ff6c03}

    .next_btn{border-radius:18px; height:36px; padding:0px 35px; background-color: #ff6100; color:white; font-weight:800; font-size:20px; line-height:36px;}
    .round_btn{display:inline-block; font-size:13px;text-align:center; line-height: 36px; height:36px; background-color:#ff6100; border-radius:18px; padding:0px 10px; color:white;}
    .round_btn + .round_btn{margin-left:10px;}

    .time_wrap{margin-left:10px;margin-top:20px;display:inline-block;font-size:15px; height:45px; line-height:45px; border-radius:10px; width:100px; text-align:center; border:1px solid #ff6100;}
    .time_wrap.active{color:white;background-color:#ff6100;}
    .time_wrap.disable{color:#ebe5e1; border-color:#ebe5e1;}

    .round_border{font-weight:800;display:inline-block; font-size:13px;text-align:center; border:1px solid #ff6100;  line-height: 36px; height:36px; border-radius:18px; padding:0px 10px; color:#ff6100;}
</style>